module.exports = __webpack_public_path__ + "img/BOR_sanford.774285f5.webp";